import { CallState } from '@lcs/shared/api';

export interface GlobalSearchListItem {
   subtitle: string;
   routerLink?: (string | number)[];
   title: string;
   searchType: string;
}

export interface GlobalSearchResultSet {
   data: {
      accounts: GlobalSearchListItem[];
      phoneNumbers: GlobalSearchListItem[];
      devices: GlobalSearchListItem[];
      softphoneUsernames: GlobalSearchListItem[];
   };
   callStates: {
      accounts: CallState;
      devices: CallState;
      phoneNumbers: CallState;
      softphoneUsernames: CallState;
   };
}

export interface GlobalSearchStatus {
   hasData: boolean;
   isLoading: boolean;
}

export interface MacAddressResult {
   accountName: string;
   deviceId: number;
   deviceType: string;
   macAddress: string;
}

export interface AccountNameResult {
   accountId: number;
   name: string;
   shortName: string;
}

export interface PhoneNumberResult {
   accountName: string;
   phoneNumber: string;
   phoneNumberId: number;
}
export interface SoftphoneUsernameResult {
   accountName: string;
   userName: string;
   extensionId: number;
   extensionNumber: number;
}

export enum NavigationDirection {
   Backward,
   Forward,
   Left,
   Right,
}
